// Photos curated from the official company profile PDF.
// Verified as real photographs (no diagrams) via image analysis.
export const PDF = {
  dataCenterEmpty: "/assets/photos/p10_i08.jpg",   // server racks aisle — hero candidate
  serverRoomCams: "/assets/photos/p16_i04.jpg",    // server room + security cameras
  buildingExterior: "/assets/photos/p04_i03.jpg",  // corporate building w/ arched entrance
  peopleDesks: "/assets/photos/p07_i03.jpg",       // three men at desks with screens
  peopleCollage: "/assets/photos/p07_i04.jpg",     // collage of professionals
  meeting: "/assets/photos/p15_i10.jpg",           // two men in discussion
  flagsCollage: "/assets/photos/p11_i04.jpg",      // people + election context (track record)
  networkCable: "/assets/photos/p12_i03.jpg",      // ethernet cable macro
  identityPortrait: "/assets/photos/p13_i04.jpg",  // portrait + ID document
};
